var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadSignature(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-cloud"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.0336 13.1777L10.0036 10.1477M10.0036 10.1477L6.97357 13.1777M10.0036 10.1477V16.9653M16.3591 14.9882C17.0979 14.5854 17.6815 13.948 18.0179 13.1767C18.3543 12.4054 18.4242 11.544 18.2166 10.7285C18.0091 9.91301 17.5358 9.18986 16.8716 8.6732C16.2075 8.15653 15.3901 7.87576 14.5486 7.8752H13.5942C13.3649 6.98835 12.9375 6.16501 12.3442 5.46709C11.751 4.76917 11.0072 4.21482 10.1688 3.84573C9.33044 3.47664 8.41931 3.30241 7.50391 3.33614C6.58852 3.36987 5.69268 3.61067 4.88375 4.04046C4.07481 4.47024 3.37384 5.07781 2.83352 5.8175C2.29319 6.55719 1.92759 7.40975 1.76419 8.31107C1.60079 9.21239 1.64384 10.139 1.89011 11.0213C2.13638 11.9036 2.57946 12.7186 3.18604 13.405",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSignature);
export default __webpack_public_path__ + "static/media/uploadSignature.f24d235e470a15f7781328ae2935076c.svg";
export { ForwardRef as ReactComponent };